import { formatInTimeZone } from "date-fns-tz";
import { isEmptyObj } from "../../../util/libObject";
import libFloat from "../../../util/libFloat";

const ListTotalReport = ({ listDataTotal }) => {
	const formatCellValue = (value, formatType) => {
		if (!value) return ""; // Evita valores undefined
		switch (formatType) {
			case "currency":
				return libFloat.strToCurrency(value);

			case "date":
				return formatInTimeZone(new Date(value), "UTC", "dd/MM/yyyy");
			// 	// return format(new Date(value), "dd/MM/yyyy");

			default:
				return value;
		}
	};

	return (
		<>
			{!isEmptyObj(listDataTotal) && (
				<>
					<ul>
						{Object.entries(listDataTotal).map(([key, { label, value, format }], index) => (
							<li key={`${key}-${index}`} className="text-[12px]">
								<strong>
									{label}: {formatCellValue(value, format)}
								</strong>
							</li>
						))}
					</ul>
				</>
			)}
		</>
	);
	// return !isEmptyObj(listDataTotal) & <div>teste</div>;
};

export default ListTotalReport;
